import React, { useState } from 'react';
import TranslationText from '../../../components/Translation/TranslationText';
import { ExclamationCircledSvg } from "components/icons/ExclamationCircledSvg";

export function SmartIdWizardBooleanQuestionPage(props) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleYesClick = () => {
    setIsSubmitting(true);
    props.onYesClicked();
  };
  return (
    <div className="row row-center">       
      <div className="column-desktop-8 column-tablet-12 column-mobile-12 centered-content">
        <div className="wizard-top-centered-icon">
          <ExclamationCircledSvg color="#871459"/>
        </div>
      </div>
      <div className="column-desktop-8 column-tablet-12 column-mobile-12 centered-content">            
					<div className="page-description-row bolded-text">
						<p style={{ fontWeight: "500" }}>
							<TranslationText text='smart_id_wizard_remove_smart_id_verification_question' />
						</p>
					</div>
          <div className="two-buttons-row">
            <button onClick={() => props.onNoClicked()} className="button -secondary">
              <span>
                <TranslationText text='smart_id_wizard_remove_smart_id_verification_no_label' />
              </span>
            </button>
            <button onClick={handleYesClick} className="button -secondary" disabled={isSubmitting}>
              <span>
                <TranslationText text='smart_id_wizard_remove_smart_id_verification_yes_label' />
              </span>
            </button>
          </div>
      </div>
    </div>   
  );
}
